$(function () {
  $(".swiper-container").each(function (index, element) {
    const $element = $(element);

    const next = $element.find(".swiper-button-next").get(0);
    const prev = $element.find(".swiper-button-prev").get(0);

    new Swiper($element.find(".swiper").get(0), {
      loop: false,
      noSwiping: true,
      noSwipingClass: ".color",
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        993: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  });

  const $swiperEl = $(".hero-swiper .swiper-product");
  const $pagination = $swiperEl.find(".pagination");
  const swiperHeroProduct = new Swiper($swiperEl.get(0), {
    slidesPerView: "auto",
    loop: true,
    pagination: {
      el: $pagination.get(0),
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 0 },
      450: { slidesPerView: 1.5, spaceBetween: 0 },
      600: { slidesPerView: 2, spaceBetween: 0 },
      767: { slidesPerView: 1.5, spaceBetween: 0 },
      850: { slidesPerView: 2, spaceBetween: 0 },
      993: { slidesPerView: 2.5, spaceBetween: 0 },
      1600: { slidesPerView: 3, spaceBetween: 0 },
    },
    on: {
      slideChange: function () {
        const swiperInstance = this;
        requestAnimationFrame(() => {
          const $activeSlide = $(
            swiperInstance.slides[swiperInstance.activeIndex],
          );
          const variantId = $activeSlide.attr("data-variant");
          if (!variantId) return;

          const $context = $swiperEl.closest("product-info");

          let $swatch = $context.find(
            '.swatches .color[data-variant-id="' + variantId + '"]',
          );
          if (!$swatch.length) {
            $swatch = $context.find(
              '.swatches .color[data-variant="' + variantId + '"]',
            );
          }
          if ($swatch.length) {
            $swatch.addClass("active").siblings(".color").removeClass("active");
          }

          let $sizeBtns = $context.find(
            '.sizes-container[data-variant="' + variantId + '"]',
          );
          if ($sizeBtns.length) {
            $sizeBtns
              .addClass("active")
              .siblings(".sizes-container")
              .removeClass("active");
            $sizeBtns
              .find(".btn-rose:not(.disabled)")
              .first()
              .addClass("active")
              .siblings()
              .removeClass("active");

            if ($sizeBtns.find(".btn-rose:not(.disabled)").length === 0) {
              $context.find(".add-to-cart").addClass("disabled");
            } else {
              $context.find(".add-to-cart").removeClass("disabled");
            }
          }

          const variantFirstSizeBtn = $context.find(
            ".sizes-container.active .btn-rose.active",
          );
          let variantIdToShow = variantFirstSizeBtn.data("variant-id");
          if (variantIdToShow) {
            $context
              .find('.product-price[data-variant="' + variantIdToShow + '"]')
              .each(function () {
                $(this).addClass("active");
                $(this).siblings().removeClass("active");
              });
          }
        });
      },
    },
  });
  // Store instance for any code that queries via data('swiper')
  $swiperEl.data("swiper", swiperHeroProduct);

  function shareNative(url, title, text, variableSecure = true) {
    if (navigator.share && variableSecure) {
      navigator
        .share({
          title: title,
          text: text,
          url: url,
        })
        .then(() => console.log("Compartido exitosamente"))
        .catch((error) => console.error("Error al compartir:", error));
    } else {
      $(".share-tooltip").addClass("show");
      $(".share-button").addClass("disabled");
      navigator.clipboard.writeText(url).then(
        function () {
          setTimeout(() => {
            $(".share-tooltip").removeClass("show");
            $(".share-button").removeClass("disabled");
          }, 2000);
        },
        function (err) {
          console.error("Error al copiar al portapapeles: ", err);
        },
      );
    }
  }

  $(document).on("click", ".share-button", function (e) {
    e.preventDefault();
    const url = window.location.href;
    const title = document.title;
    const text = "Mira este producto que encontré!";
    if (window.innerWidth < 993) {
      shareNative(url, title, text, true);
      return;
    } else {
      shareNative(url, title, text, false);
    }
  });

  $(document).on("click", ".prod-size", function (e) {
    e.preventDefault();

    if ($(this).hasClass("single-variant")) {
      //console.log("single variant, add to cart directly");
      const dataProduct = $(".add-thumb").data("product");
      let qty = 1;
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: {
          id: dataProduct,
          quantity: qty,
        },
        dataType: "json",
      })
        .done(function (item) {
          $.get(window.Shopify.routes.root + "cart?view=ajax", function (data) {
            // Update the cart drawer
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              cartDrawer.outerHTML = $(data)
                .find("cart-drawer")
                .prop("outerHTML");
            }
            const cartBubble = document.querySelector("#cart-icon-bubble");
            if (cartBubble) {
              cartBubble.outerHTML = $(data)
                .find("#cart-icon-bubble")
                .prop("outerHTML");
            }
            const newDrawer = document.querySelector("cart-drawer");
            if (newDrawer) {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  newDrawer.open();
                  $("#CartDrawer").addClass("show");
                  $(".overlay-cart-drawer").addClass("show");
                  $("body").addClass("show");
                });
              });
            }
          });
        })
        .fail(function (err) {
          console.error("Error adding to cart:", err);
          $(".toast-no-available").addClass("show");
          setTimeout(() => {
            $(".toast-no-available").removeClass("show");
          }, 3000);
        })
        .always(function () {
          $addBtn.prop("disabled", false).removeClass("loading");
        });

      return;
    }

    $("body").addClass("overflow-hidden");
    const $sheet = $(".size-data-sheet");
    const $overlay = $("#overlay-bottom-sheet");

    $overlay.addClass("show");
    $sheet.addClass("show");

    const $targetContent = $("#content-size-prod");
    $targetContent.empty();

    // Append all content inside .quick-add-container-add (but not the container itself)
    const $quickAddContent = $(".quick-add-container-add").contents();
    $targetContent.append($quickAddContent.clone());

    gsap.to($sheet, {
      y: 0,
      duration: 0.6,
      ease: "customEase",
    });

    Draggable.create($sheet.get(0), {
      trigger: $sheet.find(".drag-area").get(0),
      type: "y",
      bounds: {
        minY: $sheet.height() * 1 + 50,
        maxY: -10,
      },
      onDragEnd: function () {
        if (this.y > $sheet.height() * 0.1) {
          gsap.to($sheet, {
            y: $sheet.height() * 1 + 50,
            duration: 0.6,
            ease: "customEase",
          });

          $overlay.removeClass("show");
          $sheet.removeClass("show");
          $("body").removeClass("overflow-hidden");
        } else {
          gsap.to($sheet, {
            y: 0,
            duration: 0.6,
            ease: "customEase",
          });
        }
      },
    });
  });

  function handleChangeWidth() {
    const heightMobileInfo = $(".new-add-mobile").outerHeight();
    extraSection = document.querySelector(".extra-sections");
    heroSwiper = document.querySelector(".hero-swiper");
    innerExtra = document.querySelector(".inner-extra");

    if (heightMobileInfo > 0) {
      extraSection.style.top = `calc( 100dvh - ${heightMobileInfo}px - 50px)`;
      innerExtra.style.height = `calc( 140dvh - (100dvh - ${heightMobileInfo}px - 65px))`;
      heroSwiper.style.height = `calc(100dvh - ${heightMobileInfo}px - 100px)`;
    }

    // Refresh draggable for .inner-extra
    const $bigSheet = $(".inner-extra");
    if ($bigSheet.length && $bigSheet[0]._gsap) {
      Draggable.get($bigSheet[0])?.kill();

      Draggable.create($bigSheet.get(0), {
        trigger: $bigSheet.find(".drag-sections").get(0),
        type: "y",
        bounds: {
          minY: -window.innerHeight * 0.4,
          maxY: 0,
        },
        onDragEnd: function () {
          if (this.y < -10) {
            if (flagUpOrDown) {
              gsap.to($bigSheet, {
                y: -window.innerHeight * 0.4,
                duration: 0.6,
                ease: "customEase",
              });
              flagUpOrDown = false;
              $(".extra-sections").addClass("expanded");
            } else {
              gsap.to($bigSheet, {
                y: 0,
                duration: 0.6,
                ease: "customEase",
              });
              flagUpOrDown = true;
              $(".extra-sections").removeClass("expanded");
            }
          }
        },
      });
    }
  }

  handleChangeWidth();

  // Debounced resize listener
  let resizeTimeout;
  $(window).on("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      handleChangeWidth();
    }, 200);
  });

  $(document).on(
    "click",
    ".product-form__input--swatch .swatch-input__label",
    function (e) {
      const $this = $(this);

      const colorIndex = $this
        .closest(".product-form__input--swatch")
        .find(".swatch-input__label")
        .index($this);

      // console.log('colorindex', colorIndex+1);

      // Find the swiper in the same product section
      const $heroSwiper = $this.closest(".hero-swiper").find(".swiper-product");
      const swiper = $heroSwiper.data("swiper");

      if (!swiper) return;

      // Move to the slide with the same index as colorIndex
      swiper.slideTo(colorIndex + 3);

      // Update active state
      if (!$this.hasClass("active")) {
        $this.addClass("active").siblings().removeClass("active");
      }
    },
  );

  CustomEase.create("customEase", "0.19, 1, 0.22, 1");
  gsap.registerPlugin(Draggable);

  $(document).on("click", "[data-bottom-sheet]", function (e) {
    e.preventDefault();
    //console.log('click');
    $("body").addClass("overflow-hidden");
    const sheetId = $(this).data("bottom-sheet");
    const $sheet = $(`[data-sheet-id="${sheetId}"]`);
    const $overlay = $("#overlay-bottom-sheet");

    $overlay.addClass("show");
    $sheet.addClass("show");

    gsap.to($sheet, {
      y: 0,
      duration: 0.6,
      ease: "customEase",
    });
  });

  $(document).on("click", "#overlay-bottom-sheet", function () {
    const $overlay = $(this);
    const $sheet = $(".bottom-sheet.show");

    gsap.to($sheet, {
      y: $sheet.height() * 1 + 50,
      duration: 0.6,
      ease: "customEase",
    });

    $overlay.removeClass("show");
    $sheet.removeClass("show");
    $("body").removeClass("overflow-hidden");
  });

  $(document).on("click", ".add-thumb .color", function (e) {
    e.preventDefault();
    const $this = $(this);
    const variant = $this.data("variant");
    const $thumb = $this.closest(".add-thumb");
    const dataVariantId = $this.data("variant-id");
    const $btnAddToCart = $thumb.find(".add-to-cart");

    // if ($this.hasClass("active")) return;
    // Navigate hero swiper to the slide matching this color's variant id/index

    $thumb.find(".color").removeClass("active");
    $this.addClass("active");

    $thumb.find("[data-variant]").removeClass("active");
    $thumb.find(`[data-variant="${variant}"]`).addClass("active");

    $thumb.find(".sizes-container.active .btn-rose").removeClass("active");
    const $firstSize = $thumb
      .find(
        `.sizes-container[data-variant="${variant}"] .btn-rose:not(.disabled)`,
      )
      .first();

    if ($this.hasClass("disabled")) {
      $btnAddToCart.addClass("disabled");
    } else {
      $btnAddToCart.removeClass("disabled");
    }

    if ($firstSize.length) {
      $firstSize.addClass("active");
      const firstVariantId = $firstSize.data("variant-id");

      $('.product-price[data-variant="' + firstVariantId + '"]').each(
        function () {
          $(this).addClass("active");
          $(this).siblings().removeClass("active");
        },
      );
    }

    if (swiperHeroProduct) {
      const $slide = $(
        `.hero-swiper .swiper-slide[data-variant="${dataVariantId}"]`,
      );
      const slideIndex = $slide.attr("data-swiper-slide-index");
      //console.log('slideIndex', slideIndex);

      swiperHeroProduct.slideToLoop(slideIndex);
    }

    // Sync hero swiper handled above
  });

  $(document).on("click", ".size-data-sheet .color", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(this);
    const variant = $this.data("variant");
    const $thumb = $this.closest(".size-data-sheet");
    const $btnAddToCart = $thumb.find(".add-to-cart-size");

    $thumb.find(".color").removeClass("active");
    $this.addClass("active");

    $thumb.find("[data-variant]").removeClass("active");
    $thumb.find(`[data-variant="${variant}"]`).addClass("active");

    $thumb.find(".sizes-container.active .btn-rose").removeClass("active");
    const $firstSize = $thumb
      .find(
        `.sizes-container[data-variant="${variant}"] .btn-rose:not(.disabled)`,
      )
      .first();
    //console.log('firstSize', $firstSize);

    if ($this.hasClass("disabled")) {
      $btnAddToCart.addClass("disabled");
    } else {
      $btnAddToCart.removeClass("disabled");
    }

    if ($firstSize.length) {
      $firstSize.addClass("active");
      const firstVariantId = $firstSize.data("variant-id");

      $('.product-price[data-variant="' + firstVariantId + '"]').each(
        function () {
          $(this).addClass("active");
          $(this).siblings().removeClass("active");
        },
      );
    }
  });

  $(document).on(
    "click",
    ".size-data-sheet .sizes-container .btn-rose",
    function (e) {
      e.preventDefault();
      const $this = $(this);
      const $container = $this.closest(".sizes-container");
      const variantId = $this.data("variant-id");
      const $thumb = $this.closest(".bottom-sheet, .size-data-sheet");
      const $btnAddToCart = $thumb.find(".add-to-cart, .add-to-cart-size");

      if ($this.hasClass("active")) {
        return;
      }

      $container.find(".btn-rose").removeClass("active");
      $this.addClass("active");

      $('.product-price[data-variant="' + variantId + '"]').each(function () {
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
      });
    },
  );

  $(document).on("click", ".size-data-sheet .add-to-cart", function (e) {
    e.preventDefault();
    //console.log("click add to cart size");
    let qty = 1;
    const $addBtn = $(this);
    const $thumb = $(this).closest(".size-data-sheet");
    const $btnAddToCart = $thumb.find(".add-to-cart-size");
    let variantId;
    const activeColor = $thumb.find(".swatches .color.active");
    const colorVariantId = activeColor.data("variant");
    const activeSize = $thumb.find(".sizes-container.active .btn-rose.active");
    const sizeVariantId = activeSize.data("variant-id");
    if (colorVariantId) {
      if (sizeVariantId) {
        variantId = sizeVariantId;
      } else {
        variantId = colorVariantId;
      }
    } else {
      if (sizeVariantId) {
        variantId = sizeVariantId;
      } else {
        return;
      }
    }

    $("#overlay-bottom-sheet").removeClass("show");
    $("body").removeClass("overflow-hidden-md");
    gsap.to(".size-data-sheet", {
      y: $(".size-data-sheet").height() + 50,
      duration: 0.6,
      ease: "customEase",
    });

    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      data: {
        id: variantId,
        quantity: qty,
      },
      dataType: "json",
    })
      .done(function (item) {
        $.get(window.Shopify.routes.root + "cart?view=ajax", function (data) {
          // Update the cart drawer
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.outerHTML = $(data)
              .find("cart-drawer")
              .prop("outerHTML");
          }
          const cartBubble = document.querySelector("#cart-icon-bubble");
          if (cartBubble) {
            cartBubble.outerHTML = $(data)
              .find("#cart-icon-bubble")
              .prop("outerHTML");
          }
          const newDrawer = document.querySelector("cart-drawer");
          if (newDrawer) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                newDrawer.open();
                $("#CartDrawer").addClass("show");
                $(".overlay-cart-drawer").addClass("show");
                $("body").addClass("show");
              });
            });
          }
        });
      })
      .fail(function (err) {
        console.error("Error adding to cart:", err);
        $(".toast-no-available").addClass("show");
        setTimeout(() => {
          $(".toast-no-available").removeClass("show");
        }, 3000);
      })
      .always(function () {
        $addBtn.prop("disabled", false).removeClass("loading");
      });
  });

  $(document).on(
    "click",
    ".add-thumb .sizes-container .btn-rose",
    function (e) {
      e.preventDefault();

      const $this = $(this);
      const $thumb = $this.closest(".add-thumb");
      const $container = $this.closest(".sizes-container");

      if ($this.hasClass("active")) {
        return;
      }

      $container.find(".btn-rose").removeClass("active");
      $thumb.find(".sizes-container.active .btn-rose").removeClass("active");
      $thumb
        .find(
          '.sizes-container.active .btn-rose[data-variant-id="' +
            $this.data("variant-id") +
            '"]',
        )
        .each(function () {
          $(this).addClass("active");
        });

      $thumb
        .find('.product-price[data-variant="' + $this.data("variant-id") + '"]')
        .each(function () {
          $(this).addClass("active");
          $(this).siblings().removeClass("active");
        });
    },
  );

  $(function () {
    $(".add-thumb").each(function () {
      const $thumb = $(this);
      $thumb
        .find(".sizes-container.active .btn-rose:not(.disabled)")
        .first()
        .addClass("active");
    });
  });
  $(document).on("click", ".add-thumb .add-to-cart", function (e) {
    e.preventDefault();
    let qty = 1;
    const $addBtn = $(this);
    const $thumb = $(this).closest(".add-thumb");
    const $quickadd = $thumb.find(".quick-add-container-add");

    if ($quickadd.length === 0) {
      return;
    }

    let variantId;
    const activeColor = $quickadd.find(".swatches .color.active");
    const colorVariantId = activeColor.data("variant");
    const activeSize = $quickadd.find(
      ".sizes-container.active .btn-rose.active",
    );
    const sizeVariantId = activeSize.data("variant-id");

    if (colorVariantId) {
      if (sizeVariantId) {
        variantId = sizeVariantId;
      } else {
        variantId = colorVariantId;
      }
    } else {
      if (sizeVariantId) {
        variantId = sizeVariantId;
      } else {
        return;
      }
    }

    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      data: {
        id: variantId,
        quantity: qty,
      },
      dataType: "json",
    })
      .done(function (item) {
        $.get(window.Shopify.routes.root + "cart?view=ajax", function (data) {
          // Update the cart drawer
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.outerHTML = $(data)
              .find("cart-drawer")
              .prop("outerHTML");
          }

          const cartBubble = document.querySelector("#cart-icon-bubble");
          if (cartBubble) {
            cartBubble.outerHTML = $(data)
              .find("#cart-icon-bubble")
              .prop("outerHTML");
          }

          const newDrawer = document.querySelector("cart-drawer");
          if (newDrawer) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                newDrawer.open();
                $("#CartDrawer").addClass("show");
                $(".overlay-cart-drawer").addClass("show");
                $("body").addClass("show");
              });
            });
          }
        });
      })
      .fail(function (err) {
        console.error("Error adding to cart:", err);
        $(".toast-no-available").addClass("show");
        setTimeout(() => {
          $(".toast-no-available").removeClass("show");
        }, 3000);
      })
      .always(function () {
        $addBtn.prop("disabled", false).removeClass("loading");
      });
  });

  let flagUpOrDown = true;
  $(function () {
    setTimeout(() => {
      const $bigSheet = $(".inner-extra");
      const extraSection = document.querySelector(".extra-sections");
      Draggable.create($bigSheet.get(0), {
        trigger: $bigSheet.find(".drag-sections").get(0),
        type: "y",
        bounds: {
          minY: -window.innerHeight * 0.4,
          maxY: 0,
        },
        onDragEnd: function () {
          if (this.y < -10) {
            if (flagUpOrDown) {
              gsap.to($bigSheet, {
                y: -window.innerHeight * 0.4,
                duration: 0.6,
                ease: "customEase",
              });
              flagUpOrDown = false;
              $(".extra-sections").addClass("expanded");
            } else {
              gsap.to($bigSheet, {
                y: 0,
                duration: 0.6,
                ease: "customEase",
              });
              flagUpOrDown = true;
              $(".extra-sections").removeClass("expanded");
            }
          }
        },
      });
    }, 400);
  });
});

$(function () {
  jQuery(function ($) {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    $(window).on("beforeunload", function () {
      $(".loader").removeClass("hide");
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 40);
    });
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
    $(window).on("load", function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 0);
    });
  });

  const mq = window.matchMedia("(max-width: 768px)");

  function scrollTopStrong(retries = 5) {
    const root = document.scrollingElement || document.documentElement;
    try {
      window.scrollTo(0, 0);
    } catch (e) {}
    root.scrollTop = 0;
    document.body.scrollTop = 0;
    if (root.scrollTop > 0 && retries > 0) {
      setTimeout(() => scrollTopStrong(retries - 1), 50);
    }
  }

  function handleMobileViewport(e) {
    if (e.matches) {
      requestAnimationFrame(() => scrollTopStrong());
    }
  }
  // Initial apply
  handleMobileViewport(mq);
  // Listen for changes (cross-browser)
  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleMobileViewport);
  } else if (typeof mq.addListener === "function") {
    mq.addListener(handleMobileViewport);
  }

  const $target = $(".inner-extra");

  function moveSectionsIntoInnerExtra() {
    let allMoved = true;

    // Move related section (before footer)
    const $related = $(".related-section");
    if ($related.length && !$related.hasClass("moved-into-extra")) {
      $target.append($related);
      $related.addClass("moved-into-extra");
      allMoved = false;
    }

    // Move complementary section (before footer)
    const $complementary = $(".complementary-section");
    if ($complementary.length && !$complementary.hasClass("moved-into-extra")) {
      $target.append($complementary);
      $complementary.addClass("moved-into-extra");
      allMoved = false;
    }

    // Move footer (always last)
    let $footer = $("#shopify-section-group-footer-group");
    if (!$footer.length) {
      $footer = $(".shopify-section-group-footer-group");
    }
    if ($footer.length && !$footer.hasClass("moved-into-extra")) {
      $target.append($footer);
      $footer.addClass("moved-into-extra");
      allMoved = false;
    }

    setTimeout(() => {
      setAnimationWaypoints();
    }, 1200);

    return !allMoved; // Return true if something was moved
  }

  if (moveSectionsIntoInnerExtra()) {
    const observer = new MutationObserver(() => {
      if (moveSectionsIntoInnerExtra()) {
        // Keep observing if something changed
      } else {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    setTimeout(() => observer.disconnect(), 5000);
  }
});
